// Form di contatto: validazione del campo email che escluda domini personali come as es. gmail, libero, etc.
// non deve applicarsi al form di candidatura spontanea, al cui campo email è applicato l'ID #form-field-emailjobs
document.addEventListener('DOMContentLoaded', function() {
    const emailField = document.querySelector('input[type="email"]');
    if (emailField && emailField.getAttribute('id')!=='form-field-emailjobs') {
        emailField.addEventListener('blur', function() {
            const email = emailField.value;
            const bannedDomains = ['gmail.com', 'libero.it', 'alice.it', 'yahoo.com', 'hotmail.com', 'outlook.com'];
            const domain = email.split('@')[1];
            if (bannedDomains.includes(domain)) {
                alert('Per favore utilizza un indirizzo e-mail aziendale.');
                emailField.value = '';
            }
        });
    }
});